import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { SeasonStatuses } from "~enums/seasonStatuses";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectSeasonStatus = (props: Props) => {
  const { className, disabled, defaultValue, multiple } = props;
  const { formatMessage } = useIntl();
  const options = useMemo(
    () =>
      Object.values(SeasonStatuses).map((value) => ({
        value,
        label: formatMessage({ id: `seasonStatus.${value}` }),
      })),
    [formatMessage],
  );

  return (
    <CustomSelect
      style={{ minWidth: "130px" }}
      value={props.value}
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as { value: string; label: string }[]);
        } else {
          props.onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="status" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectSeasonStatus;
